import { mapGetters } from 'vuex'
import {
  ADD_TO_CART, ADD_VOUCHER,
  UPDATE_CHECKOUT_INFORMATIONS,
  UPDATE_QUANTITY,
  UPDATE_PRODUCT
} from '@/store/modules/shop/types'
import {SNACKBAR_MESSAGE} from "@/helpers/eventBus";

export default {
  computed: {
    ...mapGetters({
      bottles: 'getShopBottles',
      checkout: 'getCheckout',
      masterclasses: 'getShopMasterclasses'
    }),
    items() {
      if (this.checkout) {
        return this.checkout.lineItems
      }

      return []
    },
    subTotal() {
      if (!this.checkout || !this.checkout.lineItemsSubtotalPrice) {
        return ''
      }

      const parts = this.checkout.lineItemsSubtotalPrice.amount.split('.')

      return parts[0] + '.' + parts[1].toString().padEnd(2, '0')
    },
    total() {
      if (!this.checkout) {
        return ''
      }

      let total = Number(this.checkout.totalPrice)
      if (this.checkout.requiresShipping) {
        total += Number(this.shippingPrice)
      }

      const parts =  total.toString().split('.')

      if (parts && parts.length === 2) {
        return parts[0] + '.' + parts[1].toString().padEnd(2, '0')
      }

      return total.toString() + '.00'
    },
    shippingPrice() {
      return process.env.VUE_APP_SHOPIFY_SHIPPING_PRICE
    },
    requiresShipping() {
      return this.checkout && this.checkout.requiresShipping
    }
  },
  methods: {
    async addToCart(variantId, quantity, typeProduct, giftData = {}) {
      const res = await this.$store.dispatch(ADD_TO_CART, {
        variantId,
        quantity: parseInt(quantity),
        typeProduct: typeProduct, // can be 0 for bottle, 1 for masterclass, 2 for masterclass + bottle
        giftData
      })

      if (res) {
        this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: 'Ajouté au panier' })
        if (Object.entries(giftData).length !== 0) { // GTAG - Add gift product to cart
          this.$gtm.trackEvent({
            event: 'add to cart', // Event type [default = 'interaction'] (Optional)
            category: 'Shop',
            action: 'cick',
            label: 'Add gift product to cart',
            value: {
              productId: variantId,
              quantity: parseInt(quantity),
              gift: giftData
            },
            noninteraction: false // Optional
          });
        } else { // GTAG - Add product to cart
          this.$gtm.trackEvent({
            event: 'Evenement - add to card', // Event type [default = 'interaction'] (Optional)
            category: 'Shop',
            action: 'cick',
            label: 'Add product to cart',
            value: {
              productId: variantId,
              quantity: parseInt(quantity),
              gift: null
            },
            noninteraction: false // Optional
          });
        }
      } else this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: 'Erreur, remise à zéro du panier' })
    },
    async updateProduct(variantId, quantity, typeProduct, giftData = {}) {
      const res = await this.$store.dispatch(UPDATE_PRODUCT, {
        variantId,
        quantity: parseInt(quantity),
        typeProduct: typeProduct, // can be 0 for bottle, 1 for masterclass, 2 for masterclass + bottle
        giftData
      })

      if (res) {
        this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: 'Produit mis à jour' })
        if (Object.entries(giftData).length !== 0) { // GTAG - Update gift product in cart
          this.$gtm.trackEvent({
            event: 'update product', // Event type [default = 'interaction'] (Optional)
            category: 'Shop',
            action: 'click',
            label: 'Update gift product in cart',
            value: {
              productId: variantId,
              quantity: parseInt(quantity),
              gift: giftData
            },
            noninteraction: false // Optional
          });
        } else { // GTAG - Update product in cart
          this.$gtm.trackEvent({
            event: 'update product', // Event type [default = 'interaction'] (Optional)
            category: 'Shop',
            action: 'click',
            label: 'Update product in cart',
            value: {
              productId: variantId,
              quantity: parseInt(quantity),
              gift: null
            },
            noninteraction: false // Optional
          });
        }
      } else this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: 'Erreur, remise à zéro du panier' })
    },
    async updateQuantity(cartItem, quantity) {
      await this.$store.dispatch(UPDATE_QUANTITY, {
        cartItem,
        quantity
      })
      if (quantity == 0) { // GTAG - Remove product from cart
        this.$gtm.trackEvent({
          event: 'update quantity', // Event type [default = 'interaction'] (Optional)
          category: 'Shop',
          action: 'click',
          label: 'Remove product from cart',
          value: {
            productId: cartItem.variant.id,
            quantity: 0,
          },
          noninteraction: false // Optional
        });
      } else { // GTAG - Update product quantity in cart
        this.$gtm.trackEvent({
          event: 'update quantity', // Event type [default = 'interaction'] (Optional)
          category: 'Shop',
          action: 'click',
          label: 'Update product in cart',
          value: {
            productId: cartItem.variant.id,
            quantity: quantity,
          },
          noninteraction: false // Optional
        });
      }
    },
    async checkoutCart() {
      const checkout = await this.$store.dispatch(
        UPDATE_CHECKOUT_INFORMATIONS,
        this.$store.state.user.userInformations
      )

      open(checkout.webUrl, 'blank')
    },
    async addVoucher(code) {
      await this.$store.dispatch(ADD_VOUCHER, code)
    }
  }
}
